import { chapterCache } from './storage.js';

let indexPromise = null;
let translationsPromise = null;

export function loadIndex(dataUrl) {
	if (!indexPromise) {
		indexPromise = fetch(dataUrl + 'index.json', { credentials: 'omit' })
			.then((res) => {
				if (!res.ok) throw new Error('index-fetch-failed');
				return res.json();
			})
			.catch(() => null);
	}
	return indexPromise;
}

export function loadTranslations(dataUrl) {
	if (!translationsPromise) {
		translationsPromise = fetch(dataUrl + 'translations.json', { credentials: 'omit' })
			.then((res) => {
				if (!res.ok) throw new Error('translations-fetch-failed');
				return res.json();
			})
			.catch(() => ({ default: 'kjv', translations: [{ id: 'kjv', name: 'King James Version', abbrev: 'KJV' }] }));
	}
	return translationsPromise;
}

/**
 * Fetches a single chapter's JSON for the given translation, transparently
 * reading/writing the IndexedDB cache so repeat visits (and offline
 * reloads) are instant. Returns null when the chapter simply isn't part
 * of the seeded dataset for that translation.
 */
export async function loadChapter(dataUrl, translation, book, chapter, offlineCacheEnabled) {
	chapterCache.enabled = offlineCacheEnabled !== false;

	const cached = await chapterCache.get(translation, book, chapter);
	if (cached) {
		return { data: cached, fromCache: true };
	}

	try {
		const res = await fetch(`${dataUrl}${translation}/${book}/${chapter}.json`, { credentials: 'omit' });
		if (!res.ok) {
			return { data: null, fromCache: false, missing: true };
		}
		const data = await res.json();
		chapterCache.set(translation, book, chapter, data);
		return { data, fromCache: false };
	} catch (e) {
		return { data: null, fromCache: false, missing: true };
	}
}
